import React, { useState, useRef } from 'react';

function AudioPlayer({ src, autoPlay = false, onEnded }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const audioRef = useRef(null);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (onEnded) onEnded();
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      padding: '1rem',
      background: 'var(--color-secundario)',
      borderRadius: '50px',
      marginBottom: '1rem'
    }}>
      <button
        onClick={togglePlay}
        disabled={!src}
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          border: 'none',
          background: 'var(--color-acento)',
          color: 'white',
          fontSize: '1.2rem',
          cursor: src ? 'pointer' : 'not-allowed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {isPlaying ? '⏸️' : '▶️'}
      </button>
      
      <div style={{ flex: 1 }}>
        <div style={{
          height: '4px',
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '2px',
          overflow: 'hidden'
        }}>
          <div style={{
            height: '100%',
            width: loaded ? '100%' : '0%',
            background: 'var(--color-oro)',
            transition: 'width 0.3s'
          }} />
        </div>
        <p style={{ fontSize: '0.8rem', color: 'var(--color-texto-suave)', marginTop: '0.3rem' }}>
          {isPlaying ? '🔊 Escuchando al Maestro Solis...' : '🔇 Click para escuchar'}
        </p>
      </div>

      <audio
        ref={audioRef}
        src={src}
        autoPlay={autoPlay}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={handleEnded}
        onCanPlay={() => setLoaded(true)}
        style={{ display: 'none' }}
      />
    </div>
  );
}

export default AudioPlayer;